import { EmptyQueryResults } from '@/components/emptyQueryResults';

type DirectorySearchErrorProps = {
  onRetry: () => void;
};

/**
 * Shown in place of the results when the directory could not be reached. A failed search
 * must not read as "no results": that tells a reader no expert matches when the search never
 * ran.
 */
export function DirectorySearchError({ onRetry }: DirectorySearchErrorProps) {
  return (
    <EmptyQueryResults
      title="Search is unavailable"
      text="We could not reach the expert directory. Check your connection and try again."
      cta="Try again"
      onCtaPress={onRetry}
    />
  );
}
